import classNames from 'classnames';
import * as React from 'react';
import { createRef, RefObject } from 'react';

import { BannerPreviewPopupContainer } from '../../containers/BannerPreviewPopupContainer/BannerPreviewPopupContainer';
import { Bem } from '../../service/Bem/Bem';
import { TestBem } from '../../service/TestBem';
import { Banner } from '../../typings/domain';
import { GroupId } from '../../typings/groups';

import { GridBannerPreviewButton } from './GridBannerPreviewButton/GridBannerPreviewButton';
import './GridBannerPreviewCell.css';

export interface GridBannerPreviewCellProps {
    onClick: () => void;
    onGoToBannersButtonClick: (bannersIds: string[]) => void;
    bannersTotalCount: number;
    isGridScrolling: boolean;
    isTextBanner: boolean;
    banners?: Banner[];
    id: string;
    groupId: GroupId;
}

interface GridBannerPreviewCellState {
    isPopupVisible: boolean;
}

const BLOCK = 'grid-banner-preview-cell';

export class GridBannerPreviewCell extends React.Component<GridBannerPreviewCellProps, GridBannerPreviewCellState> {
    private anchor: RefObject<GridBannerPreviewButton>;

    static getDerivedStateFromProps(props: GridBannerPreviewCellProps, state: GridBannerPreviewCellState) {
        const { isGridScrolling } = props;
        const { isPopupVisible } = state;

        if (isGridScrolling && isPopupVisible) {
            return {
                isPopupVisible: false
            };
        }

        return null;
    }

    constructor(props: GridBannerPreviewCellProps) {
        super(props);

        this.anchor = createRef<GridBannerPreviewButton>();
        this.state = {
            isPopupVisible: false
        };
    }

    render() {
        const { bannersTotalCount, isTextBanner, children, id, groupId } = this.props;

        const { isPopupVisible } = this.state;

        return (
            <div
                className={classNames(
                    Bem.cls({
                        block: BLOCK,
                        mods: {
                            type: isTextBanner ? 'text' : 'image'
                        }
                    }),
                    TestBem.cls({
                        block: BLOCK,
                        mods: {
                            id
                        }
                    })
                )}
            >
                {children}
                <GridBannerPreviewButton
                    ref={this.anchor}
                    cls={Bem.cls(BLOCK, 'button')}
                    bannersCount={bannersTotalCount}
                    onClick={this.onClick}
                />
                <BannerPreviewPopupContainer
                    groupId={groupId}
                    id={id}
                    onClick={this.onPopupButtonClick}
                    anchor={this.anchor.current}
                    isVisible={isPopupVisible}
                    onCancel={this.onCancel}
                    hasTransitionButton={true}
                    showBannersCount={false}
                />
            </div>
        );
    }

    private onClick = () => {
        this.props.onClick();
        this.setState({
            isPopupVisible: true
        });
    };

    private onCancel = () => {
        this.setState({
            isPopupVisible: false
        });
    };

    private onPopupButtonClick = () => {
        const { onGoToBannersButtonClick, banners = [] } = this.props;

        onGoToBannersButtonClick(banners.map(el => el.id));
    };
}
